__turbopack_context__.v({
  "button": "link-block-module-scss-module__AKAgCa__button",
  "internal-icon": "link-block-module-scss-module__AKAgCa__internal-icon",
});
